// extracted by mini-css-extract-plugin
export default {"main":"Main_main__9f+eI","container":"Main_container__726Hn","left__area":"Main_left__area__EGJe4","left__menu":"Main_left__menu__dnw-o","main__area":"Main_main__area__9g1i-"};